'use strict';

// import Swiper bundle with all modules installed
import Swiper from 'swiper';
import {A11y, Autoplay, EffectFade, Keyboard, Navigation, Pagination} from 'swiper/modules';
import GLightbox from 'glightbox';

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

//import "accordionjs/accordion.min";

function J3WTheme() {

    var self = this;

    self.$window = $(window);
    self.$document = $(document);
    self.$body = $("body");
    self.$header = $("#js-header");
    self.$hamburger = $(".hamburger");
    self.$mainMenu = $("#js-main-menu");
    self.$mainNav = $("#main-nav");
    self.$mobileMenu = $("#js-mobile-menu");

    self.init();
}

J3WTheme.prototype = {

    init: function () {

        var self = this;

        self.onBind();
        //self.cloneMainMenu();
        self.lightbox();
        //self.accordion();
        self.swiperHeroInit();
        self.wrapWideTables();
        //self.carouselInit();

    },

    onBind: function () {

        var self = this;

        self.$window.on('scroll', function () {
            self.bodyScrollClass(self);
        });

        self.$hamburger.on("click", function () {
            self.mobileMenu();
        });

        $("#js-open-search").on("click", function(){
            var isOpen = $("#js-searchbar").toggleClass("searchbar--open").hasClass("searchbar--open");

            $(this).attr("aria-expanded", isOpen ? "true" : "false");

            if (isOpen) {
                setTimeout(function() {
                    $("#js-search-text").focus();
                }, 300 );
            }
        });

        $("#js-searchbar-bg").on("click", function(){
            self.closeSearch();
        });

        self.$document.keydown(function (e) {
            var $searchbar = $("#js-searchbar");

            if (e.cancelable === true && e.key === 'Esc' || e.key === 'Escape' || e.keyCode === 27) {
                if ($searchbar.hasClass("searchbar--open")) {
                    self.closeSearch();
                    $("#js-open-search").focus();
                }
                if (self.$mobileMenu.hasClass("mobile-menu--open")) {
                    self.mobileMenu();
                }
            }

            // Jen jeden z obou muze byt otevreny, menu ma prednost.
            if (self.$mobileMenu.hasClass("mobile-menu--open")) {
                self.trapFocus(e, self.$mobileMenu);
            }
            else if ($searchbar.hasClass("searchbar--open")) {
                self.trapFocus(e, $searchbar);
            }
        });

        $(".more-info-btn").on("click", function(e) {
            $("#more-info").toggleClass("open");
            $(this).toggleClass("btn-icon--arr-expand btn-icon--arr-expand-less");
            e.preventDefault();
        });

        // Filtr mesicu v kalendari. Druhe klepnuti na uz vybrany mesic vyber zrusi -
        // radio button to sam neumi, proto si pamatujeme predchozi stav.
        $(".js-calendar-filter").on("click", function() {
            var $inputs = $(".js-calendar-filter");

            if ($(this).data("wasChecked")) {
                this.checked = false;
            }

            $inputs.data("wasChecked", false);
            $(this).data("wasChecked", this.checked);

            this.form.requestSubmit();
        });

        $(".js-mobile-submenu-open").on( "click", function() {
            var isOpen = $(this).toggleClass("_opened").hasClass("_opened");

            $(this).attr("aria-expanded", isOpen ? "true" : "false")
                .closest("li").find("> ul").slideToggle( 300 );
        } );

    },

    closeSearch: function () {

        $("#js-searchbar").removeClass("searchbar--open");
        $("#js-open-search").attr("aria-expanded", "false");

    },

    // Prvky dosazitelne tabulatorem. Skryte vetve podmenu odfiltruje :visible.
    focusableSelector: 'a[href], button:not([disabled]), input:not([disabled]), ' +
        'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',

    // Pri otevrenem menu nebo vyhledavani nesmi tabulator odejit do stranky pod nimi.
    // Tlacitko, ktere panel zavira, lezi uvnitr obou kontejneru, takze cesta ven zustava.
    // (WCAG 2.4.3)
    trapFocus: function (e, $container) {

        var self = this;

        if (e.key !== 'Tab' && e.keyCode !== 9) {
            return;
        }

        var $items = $container.find(self.focusableSelector).filter(':visible');

        if (!$items.length) {
            return;
        }

        var first = $items.first()[0];
        var last = $items.last()[0];

        if (!$.contains($container[0], document.activeElement)) {
            first.focus();
            e.preventDefault();
        }
        else if (e.shiftKey && document.activeElement === first) {
            last.focus();
            e.preventDefault();
        }
        else if (!e.shiftKey && document.activeElement === last) {
            first.focus();
            e.preventDefault();
        }

    },

    // Siroke tabulky z CMS obalime scrollovatelnou oblasti dosazitelnou z klavesnice
    wrapWideTables: function () {

        $(".the-content table, .page__content table").each(function () {
            var $table = $(this);

            if ($table.parent(".table-scroll").length) {
                return;
            }

            $table.wrap('<div class="table-scroll" tabindex="0" role="region" aria-label="Tabulka, posuvná vodorovně"></div>');
        });

    },

    accordion: function(){

        $(".accordion").accordionjs({
            // Allow self close.(data-close-able)
            closeAble   : true,
            // Close other sections.(data-close-other)
            closeOther  : false,
            // Animation Speed.(data-slide-speed)
            slideSpeed  : 300,
            // The section open on first init. A number from 1 to X or false.(data-active-index)
            activeIndex : false,
            // Callback when a section is open
            //openSection: function( section ){},
            // Callback before a section is open
            //beforeOpenSection: function( section ){},
        });

        // Otevirame podle hashe v URL adrese
        var hash = new URL(document.URL).hash;

        if ( hash && $(".accordionjs").length > 0 ) {
            $(hash).addClass( "acc_active" ).find(".acc_content").show();
            $("html, body").animate({
                scrollTop: $(hash).offset().top - 100 // offset
            }, 150);
        }

    },

    mobileMenu: function(){

        var self = this, t;

        clearTimeout( t );

        //self.$body.toggleClass("mobile-menu-is-open");

        var $hamburger = $(".hamburger");

        if( self.$mobileMenu.hasClass("mobile-menu--open") ){
            self.$mobileMenu.removeClass("mobile-menu--open");
            $hamburger.attr("aria-expanded", "false");
            $(".header__hamburger").focus();
            t = setTimeout( function(){
                $hamburger.removeClass("is-active");
            }, 200 );
        }
        else {
            self.$mobileMenu.addClass("mobile-menu--open");
            $hamburger.attr("aria-expanded", "true");
            t = setTimeout( function(){
                $hamburger.addClass("is-active");
                self.$mobileMenu.find(".mobile-menu__hamburger").focus();
            }, 200 );
        }

    },

    cloneMainMenu: function(){

        $("#js-main-menu:not(.cloned)").addClass("cloned")
            .clone( true, true )
            .removeAttr("id")
            .appendTo("#js-sticky-menu-container");

    },

    bodyScrollClass: function ( self ) {

        //if( self.$document.scrollTop() > self.$header.outerHeight() ) {
        if( self.$document.scrollTop() > 0 ) {
            self.$body.addClass('js-scrolling');
        }
        else {
            self.$body.removeClass('js-scrolling');
        }
/*
        // potrebujeme vedet, jestli se scrolluje dolu nebo nahoru
        if ( ( document.body.getBoundingClientRect() ).top > self.scrollPos ) {
            self.$body.addClass('scroll-up');
        } else {
            self.$body.removeClass('scroll-up');
        }

        self.scrollPos = ( document.body.getBoundingClientRect() ).top;

        if( self.$document.scrollTop() < self.$header.outerHeight() + 100 ) {
            self.$body.addClass('hide-menu');
        } else {
            self.$body.removeClass('hide-menu');
        }
*/
    },

    lightbox: function() {

        if (!$('.glightbox').length) {
            return;
        }

        // Vychozi sablona GLightboxu ma anglicke aria-label. Prebijime ji celou, jinak
        // odecitac precte tlacitka anglicky. Zastupne znacky {closeSVG} a spol. doplni
        // knihovna sama.
        var lightboxHTML = '<div id="glightbox-body" class="glightbox-container" tabindex="-1" role="dialog" aria-label="Fotografie" aria-hidden="false">' +
            '<div class="gloader visible"></div>' +
            '<div class="goverlay"></div>' +
            '<div class="gcontainer">' +
            '<div id="glightbox-slider" class="gslider"></div>' +
            '<button class="gclose gbtn" aria-label="Zavřít" data-taborder="3">{closeSVG}</button>' +
            '<button class="gprev gbtn" aria-label="Předchozí fotografie" data-taborder="2">{prevSVG}</button>' +
            '<button class="gnext gbtn" aria-label="Další fotografie" data-taborder="1">{nextSVG}</button>' +
            '</div>' +
            '</div>';

        GLightbox({
            selector: '.glightbox',
            lightboxHTML: lightboxHTML,
            loop: true,
            // Prechody mezi snimky respektuji nastaveni systemu. (WCAG 2.3.3)
            openEffect: prefersReducedMotion() ? 'none' : 'zoom',
            closeEffect: prefersReducedMotion() ? 'none' : 'zoom',
            slideEffect: prefersReducedMotion() ? 'none' : 'slide'
        });
    },

    swiperHeroInit: function() {

        var self = this;

        self.swiperHero = new Swiper('#js-swiper-hero', {
            modules: [
                A11y,
                Autoplay,
                EffectFade,
                Navigation,
                Pagination,
                Keyboard
            ],
            loop: true,
            speed: 900,
            // Bez A11y modulu jsou sipky <div> bez role a bez tab stopu
            a11y: {
                enabled: true,
                prevSlideMessage: 'Předchozí snímek',
                nextSlideMessage: 'Další snímek',
                firstSlideMessage: 'První snímek',
                lastSlideMessage: 'Poslední snímek',
                paginationBulletMessage: 'Přejít na snímek {{index}}',
                slideLabelMessage: 'Snímek {{index}} z {{slidesLength}}',
                containerMessage: 'Úvodní prezentace'
            },
            // Automaticke prehravani se vypina, kdyz uzivatel omezil pohyb v systemu
            autoplay: prefersReducedMotion() ? false : {
                delay: 5000,
                disableOnInteraction: true,
                pauseOnMouseEnter: true
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            preloadImages: true,
            //lazyLoading: true,
            //lazy: {
            //    loadPrevNext: true,
            //},
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            /*
            pagination: {
                el: '.swiper-hero-pagination',
                type: 'bullets',
                clickable: true
            }
            */
        });
    },

    carouselInit: function() {

        var self = this;

        self.swiperHero = new Swiper('#js-carousel', {
            loop: true,
            speed: 900,
            autoplay: {
                delay: 2000,
                disableOnInteraction: true
            },
            //effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            preloadImages: false,
            navigation: {
                nextEl: '.carousel-nav--next',
                prevEl: '.carousel-nav--prev'
            },
            on: {
                transitionEnd: function() {
                    // vanilla lazyload
                    lazyLoadInstance.update();
                }
            },
            /*
            pagination: {
                el: '.swiper-hero-pagination',
                type: 'bullets',
                clickable: true
            }*/
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                // when window width is >= 420px
                420: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 40
                }
            }
        });
    }
};

$(document).ready(function () {
    new J3WTheme();
});

// Puvodne kvuli fancyboxu, ten uz tu neni. Zustava kvuli inline skriptum
// v redakcnim obsahu z CMS, ktere pocitaji s globalni jQuery.
window.jQuery = window.$ = $;
